<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <div class="col-sm-9">
            <span>Info</span>
        </div>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form *ngIf="data"
                  #form="ngForm"
                  (ngSubmit)="update(form)"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">

                <!--** Emergency Contact ** -->
                <emergency-contacts-field *ngIf="!isSuperAdmin"
                                          [ngModel]="data.emergencyContacts"
                                          name="emergencyContacts"
                                          [title]="'Emergency Contact'"
                                          (update)="update({emergencyContacts: form.value.emergencyContacts})"
                                          [noEdit]="!data.isCanEdit">
                </emergency-contacts-field>

                <hr>

                <!--** Instructions ** -->
                <div class="row m-b-xs" *ngIf="data.instructions.length > 0">
                    <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                        Instructions
                    </div>

                    <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                         *ngIf="!showInstructionsHistory && numberOfCurrentInstructions() < data.instructions.length"
                         (click)="showInstructionsHistory = true">
                        + Show Instructions History
                    </div>

                    <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                         *ngIf="showInstructionsHistory || numberOfCurrentInstructions() == data.instructions.length"
                         (click)="showInstructionsHistory = false">
                        - Hide Instructions History
                    </div>
                </div>

                <div class="row m-b-xs resident-instructions-row"
                     *ngFor="let instruction of getInstructions(); let index = index;">
                    <div class="col-sm-12 m-b-xs">
                        <label>{{instruction.subject}}</label>
                        <pre>{{instruction.text}}</pre>
                    </div>
                    <div class="dv-label col-sm-12">
                        <span class="same-label-width label label-{{instruction.status}} m-r-sm">{{instruction.status}}</span>
                        {{instruction.startDate | date:'dd.MM.yyyy'}} <span *ngIf="instruction.endDate"> - {{instruction.endDate | date:'dd.MM.yyyy'}}</span>
                    </div>
                    <div class="dv-label col-sm-12">
                        Assigned to: {{instruction.user?.fullName}}
                        <i *ngIf="data.isCanDelete"
                           class="fa fa-trash pull-right"
                           (click)="directoryService.deleteInstructionFromUnit(instruction)">
                        </i>
                        <i *ngIf="data.isCanEdit"
                           (click)="directoryService.editInstructionFromUnitView(instruction)"
                           class="fa fa-pencil pull-right">
                        </i>
                    </div>
                </div>

                <hr *ngIf="data.instructions.length > 0">

                <!--** Level ** -->
                <input-field [ngModel]="data.level"
                             name="level"
                             [tooltipText]="'Level'"
                             [title]="'Level'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({level: form.value.level})">
                </input-field>

                <!--** Enter Phone ** -->
                <input-field [ngModel]="data.enterPhone"
                             name="enterPhone"
                             [tooltipText]="'Enter Phone'"
                             [title]="'Enter Phone'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({enterPhone: form.value.enterPhone})">
                </input-field>

                <!--** Sub Name ** -->
                <input-field [ngModel]="data.subName"
                             name="subName"
                             [tooltipText]="'Sub Name'"
                             [title]="'Sub Name'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({subName: form.value.subName})">
                </input-field>

                <!--** Level ** -->
                <boolean-field [ngModel]="data.fromFiveReceived"
                               name="fromFiveReceived"
                               [tooltipText]="'Form Five Received'"
                               [title]="'Form Five Received'"
                               [noEdit]="!data.isCanEdit"
                               (update)="update({fromFiveReceived: form.value.fromFiveReceived})">
                </boolean-field>

                <!--** Prop. Share %: ** -->
                <input-field [ngModel]="data.proportionateShare"
                             name="proportionateShare"
                             [tooltipText]="'Prop. Share %'"
                             [title]="'Prop. Share %'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({proportionateShare: form.value.proportionateShare})">
                </input-field>

                <!--** Common Elements Fee: ** -->
                <input-field [ngModel]="data.commonElementsFee"
                             name="commonElementsFee"
                             [tooltipText]="'Common Elements Fee'"
                             [title]="'Common Elements Fee'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({commonElementsFee: form.value.commonElementsFee})">
                </input-field>

                <!--** OCCUPANCY DATE ** -->
                <datetime-field [ngModel]="data.occupancyDate"
                                [value]="data.occupancyDate"
                                name="occupancyDate"
                                [title]="'Occupancy Date'"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [noEdit]="!data.isCanEdit"
                                (update)="update({occupancyDate: convertDate(form.value.occupancyDate)})">
                </datetime-field>

                <hr>

                <!--** Buzz ** -->
                <directory-unit-array-input-field [ngModel]="data.buzzFields"
                                                  name="buzz"
                                                  [tooltipText]="'Buzz'"
                                                  [title]="'Buzz'"
                                                  [suiteUsers]="data.suiteUser"
                                                  [noEdit]="!data.isCanEdit"
                                                  (update)="submitKeyFields('buzzFields', form.value.buzz)">
                </directory-unit-array-input-field>

                <!--** Key Code ** -->
                <directory-unit-array-input-field [ngModel]="data.keyCodeFields"
                                                  name="keyCode"
                                                  [tooltipText]="'Key Code'"
                                                  [title]="'Key Code'"
                                                  [suiteUsers]="data.suiteUser"
                                                  [noEdit]="!data.isCanEdit"
                                                  (update)="submitKeyFields('keyCodeFields', form.value.keyCode)">
                </directory-unit-array-input-field>

                <!--** Key Fob ** -->
                <directory-unit-array-input-field [ngModel]="data.keyFobFields"
                                                  name="keyFob"
                                                  [tooltipText]="'Key Fob'"
                                                  [title]="'Key Fob'"
                                                  [suiteUsers]="data.suiteUser"
                                                  [noEdit]="!data.isCanEdit"
                                                  (update)="submitKeyFields('keyFobFields', form.value.keyFob)">
                </directory-unit-array-input-field>

                <hr>

                <!--** POWER_ATTORNEY ** -->
                <input-field [ngModel]="data.powerAttorney"
                             name="powerAttorney"
                             [tooltipText]="'Power Attorney'"
                             [title]="'Power Attorney'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({powerAttorney: form.value.powerAttorney})">
                </input-field>

                <!--** legalDescription ** -->
                <input-field [ngModel]="data.legalDescription"
                             name="legalDescription"
                             [tooltipText]="'Legal Description'"
                             [title]="'Legal Description'"
                             [noEdit]="!data.isCanEdit"
                             (update)="update({legalDescription: form.value.legalDescription})">
                </input-field>

                <!--** RentedOut ** -->
                <boolean-field [ngModel]="data.rentedOut"
                               name="rentedOut"
                               [tooltipText]="'Rented Out'"
                               [title]="'Rented Out'"
                               [noEdit]="!data.isCanEdit"
                               (update)="update({rentedOut: form.value.rentedOut})">
                </boolean-field>

                <div class="m-b-md m-t-md">
                    <hr>
                </div>

                <!--** note ** -->
                <textarea-field [ngModel]="data.note"
                                [maxLength]="255"
                                name="note"
                                [tooltipText]="'Note'"
                                [title]="'Note'"
                                [noEdit]="!data.isCanEdit"
                                (update)="update({note: form.value.note})">
                </textarea-field>

                <div class="m-b-md m-t-md">
                    <hr>
                </div>

                <!--** Allowed visitor ** -->
                <textarea-field [ngModel]="data.allowedVisitor"
                                [maxLength]="255"
                                name="allowedVisitor"
                                [tooltipText]="'Allowed Visitors'"
                                [title]="'Allowed Visitors'"
                                [noEdit]="!data.isCanEdit"
                                (update)="update({allowedVisitor: form.value.allowedVisitor})">
                </textarea-field>

                <!--** Permission To Enter ** -->
                <textarea-field [ngModel]="data.permissionToEnter"
                                [maxLength]="255"
                                name="permissionToEnter"
                                [tooltipText]="'Permission To Enter'"
                                [title]="'Permission To Enter'"
                                [noEdit]="!data.isCanEdit"
                                (update)="update({permissionToEnter: form.value.permissionToEnter})">
                </textarea-field>
            </form>
        </div>
    </div>
    <spinner [spinnerShow]="parent.spinnerShow"></spinner>
</div>
<add-instructions-modal *ngIf="directoryService.showAddInstructionsModal"></add-instructions-modal>



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/info/info.template.html